
import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Users = lazy(() => import(`Pages/Admin/Users/Page`));

const UsersRoutes: RouteObject[] = [
    {
        path: 'usuarios',
        element: <LoadComponent component={Users} />,
    },
]

export default UsersRoutes;
